import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class AccordionService {
  private accordionSource = new BehaviorSubject({
    window: null,
    irregularEdge: null,
  });
  accordion$ = this.accordionSource.asObservable();

  get accordion(): any {
    return this.accordionSource.value;
  }

  set accordion(accordion: any) {
    this.accordionSource.next(accordion);
  }


  private canvasEventSource = new BehaviorSubject(null);

  canvasEvent$ = this.canvasEventSource.asObservable();
  private _canvasEvent: number;

  set canvasEvent(canvasEvent: number) {
    this._canvasEvent = canvasEvent;
    this.canvasEventSource.next(canvasEvent);
  }

  get canvasEvent() {
    return this._canvasEvent;
  }
}
